import { render, staticRenderFns } from "./EmployeeTraining.vue?vue&type=template&id=fc1f304e&"
import script from "./EmployeeTraining.vue?vue&type=script&lang=js&"
export * from "./EmployeeTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc1f304e')) {
      api.createRecord('fc1f304e', component.options)
    } else {
      api.reload('fc1f304e', component.options)
    }
    module.hot.accept("./EmployeeTraining.vue?vue&type=template&id=fc1f304e&", function () {
      api.rerender('fc1f304e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/EmployeeDetails/EmployeeTraining.vue"
export default component.exports